//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminCompanyController_listMemberships,
  Response$AdminCompanyController_listMemberships$Status$200,
  ResponseContentType$AdminCompanyController_listMemberships,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useAdminCompanyController_listMemberships = (options: {
  params: Params$AdminCompanyController_listMemberships['parameter'];
  config?: QueryOptions<
    Response$AdminCompanyController_listMemberships$Status$200[ResponseContentType$AdminCompanyController_listMemberships]
  >;
}) =>
  useApiClient<
    Params$AdminCompanyController_listMemberships,
    Response$AdminCompanyController_listMemberships$Status$200[ResponseContentType$AdminCompanyController_listMemberships]
  >({
    method: 'AdminCompanyController_listMemberships',
    params: { parameter: options.params },
    config: options.config,
  });
